import { Reveal, Overline } from "./Reveal";
import { Lightbulb, LineChart, CandlestickChart, ListChecks, Coins, Rocket } from "lucide-react";

const MODULES = [
  { i: Lightbulb, n: "01", t: "Investment FUNdaMENTALS", d: "Reset your mindset, master emotional control and the psychology of a profitable investor." },
  { i: LineChart, n: "02", t: "Fundamental Analysis (FA)", d: "Read financials, key ratios and intrinsic value to understand what a business is truly worth." },
  { i: CandlestickChart, n: "03", t: "Technical Analysis (TA)", d: "Charts, trends and timing — knowing when to enter and exit with confidence." },
  { i: ListChecks, n: "04", t: "Your Exponential Watchlist", d: "Build and maintain a curated watchlist engineered for asymmetric opportunity." },
  { i: Coins, n: "05", t: "Income Generator Option xTrategy", d: "I-GOT — generate consistent monthly income using disciplined options strategies." },
  { i: Rocket, n: "06", t: "Exponential Growth Option xTrategy", d: "E-GOT — advanced options plays designed for exponential capital growth." },
];

export default function Modules() {
  return (
    <section id="modules" data-testid="modules-section" className="relative py-28 md:py-40 bg-surface/30 border-y border-white/10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <Reveal className="max-w-xl">
            <Overline>Curriculum</Overline>
            <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-tight text-white mt-5">
              Six modules. One complete investrader.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-slate-400 max-w-sm md:text-right">
              20 sessions total — 10 strategic learning, 10 live trading. 90 minutes each, live on Zoom with full recordings.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {MODULES.map((m, idx) => {
            const Icon = m.i;
            return (
              <Reveal key={m.n} delay={idx * 0.07}>
                <div
                  data-testid={`module-card-${m.n}`}
                  className="group relative h-full rounded-2xl border border-white/10 hover:border-burgundy bg-ink p-8 transition-colors duration-500 overflow-hidden"
                >
                  <div className="flex items-center justify-between mb-8">
                    <div className="h-12 w-12 rounded-xl border border-white/10 flex items-center justify-center text-slate-300 group-hover:text-burgundy group-hover:border-burgundy/50 transition-colors duration-500">
                      <Icon size={22} />
                    </div>
                    <span className="font-mono text-xs text-slate-500">MODULE {m.n}</span>
                  </div>
                  <h3 className="font-display text-2xl md:text-3xl text-white leading-tight">
                    {m.t}
                  </h3>
                  <p className="text-slate-400 text-sm mt-4 leading-relaxed">{m.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
